import { transition } from '@helpers/animate';
import brand from '@helpers/brand';
import { fluid } from '@helpers/fluid';
import fonts from '@helpers/fonts';
import srOnly from '@helpers/srOnly';
import SectionWrapper from '@stories/Components/Misc/SectionWrapper/SectionWrapper';
import styled from 'styled-components';
const Container = styled(SectionWrapper) `
  --sectionColour: ${brand.primary.white};

  width: 100%;

  &[data-variant='default'] {
    --sectionBackground: ${brand.primary.orange};
    --sectionSpacingTop: 10px;
    --sectionSpacingBottom: 10px;
  }

  &[data-variant='embedded'] {
    --sectionBackground: transparent;
  }
`;
const List = styled.ul `
  ${fonts.poppins.regular};

  color: var(--sectionColour);
  font-size: ${fluid(14, 22)};
  line-height: ${fluid(16, 36)};
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
  width: 100%;
  margin: 0;
`;
const Item = styled.li `
  display: inline;
  margin: 0 ${fluid(10, 12)} 0 0;

  svg {
    width: ${fluid(7, 10)};
    margin-left: ${fluid(10, 12)};
    transform: translateY(-25%) rotate(-90deg);
  }

  &[data-hidden='true'] {
    ${srOnly};
  }

  &:last-child {
    margin: 0;
  }
`;
const ItemLink = styled.a `
  ${transition('text-decoration-color')};

  text-decoration: underline;
  text-decoration-color: transparent;
  text-underline-offset: 3px;
  white-space: nowrap;
  color: currentColor;

  &[aria-current='location'] {
    font-weight: 600;
  }

  &:not([aria-current='location']).focus-ring,
  &:not([aria-current='location']):hover {
    text-decoration-color: currentColor;
  }
`;
const BreadcrumbsStyles = {
    Container,
    List,
    Item,
    ItemLink,
};
export default BreadcrumbsStyles;
